<cc-data-grid-features
    *ngIf="!!dataSource"
    #gridFeatures
    [stateConfig]="{ storageKey: storageKey, storeGroupings: true }"
    [dataSource]="dataSource"
>
    <dx-data-grid
        #queueGrid
        appHasInternalUserColumns
        width="100%"
        height="100%"
        class="cc-vertical-center-cell-data-grid"
        [dataSource]="dataSource"
        (onContentReady)="onGridContentReady()"
    >
        <ng-container *ngIf="isActionAvailable">
            <dxi-column
                type="buttons"
                caption="Action"
                alignment="center"
                [width]="110"
                [visibleIndex]="0"
                [allowGrouping]="false"
                [showInColumnChooser]="false"
                cellTemplate="actionTemplate"
            ></dxi-column>
        </ng-container>
        <dxi-column
            dataField="workflowId"
            caption="Workflow Id"
            dataType="string"
            [visibleIndex]="1"
            [allowGrouping]="false"
        ></dxi-column>
        <dxi-column
            caption="Invoice"
            alignment="center"
            cellTemplate="invoiceFileCellTemplate"
            [visibleIndex]="2"
            [allowGrouping]="false"
        ></dxi-column>
        <dxi-column dataField="status" caption="Status" dataType="string" [visibleIndex]="3"></dxi-column>
        <dxi-column
            dataField="createdOn"
            caption="Created On"
            dataType="date"
            [format]="dateFormat"
            [visibleIndex]="4"
        ></dxi-column>
        <dxi-column dataField="handling" caption="Handling" dataType="string" [visibleIndex]="5"></dxi-column>
        <dxi-column dataField="location" caption="Location" dataType="string" [visibleIndex]="6"></dxi-column>
        <dxi-column
            dataField="community"
            caption="Community"
            dataType="string"
            cellTemplate="communityTemplate"
            [visibleIndex]="7"
        ></dxi-column>
        <dxi-column
            dataField="dueDate"
            caption="Due Date"
            dataType="date"
            [format]="dateFormat"
            [visibleIndex]="8"
        ></dxi-column>
        <dxi-column dataField="description" caption="Description" dataType="string" [visibleIndex]="9"></dxi-column>
        <dxi-column
            name="InternalLogs"
            caption="Log"
            alignment="center"
            cellTemplate="logCellTemplate"
            [visibleIndex]="10"
            [allowGrouping]="false"
        ></dxi-column>
        <dxi-column
            name="InternalNotes"
            caption="Notes"
            alignment="center"
            cellTemplate="notesCellTemplate"
            [visibleIndex]="11"
            [allowGrouping]="false"
        ></dxi-column>
        <ng-container *ngIf="!isLiteMode">
            <dxi-column
                caption="Responsible"
                dataType="string"
                dataField="responsibleUsers"
                cellTemplate="responsibleTemplate"
                [visibleIndex]="12"
                [visible]="!isLiteMode"
                [showInColumnChooser]="!isLiteMode"
                [allowGrouping]="false"
            >
                <dxo-header-filter [dataSource]="uniqueResponsibleUsers"></dxo-header-filter>
            </dxi-column>
            <dxi-column
                dataType="string"
                dataField="addedByUsersDisplayText"
                caption="Initiated By"
                cellTemplate="addedByTemplate"
                [allowGrouping]="false"
                [visible]="!isLiteMode"
                [showInColumnChooser]="!isLiteMode"
            ></dxi-column>
        </ng-container>
        <dxi-column
            dataField="managementCompanyName"
            caption="Management Company"
            dataType="string"
            [visibleIndex]="13"
            [visible]="false"
        ></dxi-column>
        <dxi-column
            dataType="boolean"
            dataField="addedByCam"
            caption="CAM Initiated"
            cellTemplate="booleanCheckTemplate"
            [visible]="false"
        ></dxi-column>
        <dxi-column
            dataField="invoiceDate"
            caption="Invoice Date"
            dataType="date"
            [format]="dateFormat"
            [visible]="false"
        ></dxi-column>

        <div *dxTemplate="let t of 'actionTemplate'">
            <app-grid-actions-menu
                *ngIf="hasAction(t.data)"
                [actionMenuItems]="actionMenuItems"
                [record]="t.data"
                [rowIndex]="t.rowIndex"
                [isActionVisible]="isActionItemVisible"
                (onActionClick)="onActionItemClick($event)"
            ></app-grid-actions-menu>
        </div>

        <div *dxTemplate="let d of 'booleanCheckTemplate'">
            <div *ngIf="d.value">
                <i class="cc-1-5x cc-icon-check" [ngClass]="iconCheck"></i>
            </div>
        </div>

        <div *dxTemplate="let a of 'logCellTemplate'">
            <div *ngIf="a.data.community">
                <i
                    class="cc-1-5x icon-content dx-theme-accent-as-text-color"
                    [ngClass]="iconHistory"
                    (click)="onLogClick(a.data)"
                ></i>
            </div>
        </div>

        <div *dxTemplate="let d of 'notesCellTemplate'">
            <div *ngIf="d.data.hasNotes">
                <i
                    class="cc-1-5x icon-content cc-icon-content cc-icon-check"
                    [ngClass]="iconNotes"
                    (click)="onWorkflowNotesClick(d.data)"
                ></i>
            </div>

            <div *ngIf="!d.data.hasNotes">
                <i
                    class="cc-1-5x icon-content dx-theme-accent-as-text-color"
                    [ngClass]="iconEmptyNotes"
                    (click)="onWorkflowNotesClick(d.data)"
                ></i>
            </div>
        </div>

        <div *dxTemplate="let d of 'invoiceFileCellTemplate'">
            <i class="cc-1-5x icon-content cc-icon-pdf" [ngClass]="iconPDF" (click)="onDownloadFile(d.data)"></i>
        </div>

        <div *dxTemplate="let row of 'communityTemplate'">
            <app-property-community-link
                *ngIf="row.data.community"
                [communityId]="row.data.communityId"
                [displayText]="row.value"
            ></app-property-community-link>
        </div>

        <div *dxTemplate="let r of 'responsibleTemplate'" class="responsible-container">
            <ng-container
                *ngIf="!!r.data.dashboardResponsibleUsers && r.data.dashboardResponsibleUsers.length === 1"
                [ngTemplateOutlet]="singleUserTemplate"
                [ngTemplateOutletContext]="{ data: r.data, user: r.data.dashboardResponsibleUsers[0] }"
            ></ng-container>
            <ng-container
                *ngIf="!!r.data.dashboardResponsibleUsers && r.data.dashboardResponsibleUsers.length > 1"
                [ngTemplateOutlet]="multiUsersTemplate"
                [ngTemplateOutletContext]="{ data: r.data }"
            ></ng-container>
        </div>

        <div *dxTemplate="let r of 'addedByTemplate'" class="responsible-container">
            <ng-container
                [ngTemplateOutlet]="singleUserTemplate"
                [ngTemplateOutletContext]="{
                    data: r.data,
                    user: r.data.addedBy
                }"
            ></ng-container>
        </div>

        <dxo-summary>
            <dxi-group-item column="workflowId" summaryType="count" displayFormat="Count = {0}"></dxi-group-item>
        </dxo-summary>
    </dx-data-grid>
</cc-data-grid-features>

<ng-template #singleUserTemplate let-user="user" let-data="data">
    <div class="res-content">
        <app-user-bio-link [user]="user" [communityId]="data.communityId"></app-user-bio-link>
    </div>
</ng-template>

<ng-template #multiUsersTemplate let-data="data">
    <app-hyperlink-creator
        cssCass="cc-hyperlink-hover"
        [displayText]="data.responsibleUsers"
        (onLinkClick)="showUsersList(data)"
    ></app-hyperlink-creator>
</ng-template>

<dx-popup
    *ngIf="!!selectedWorkflow"
    [title]="'Responsible Users for #' + selectedWorkflow?.workflowId"
    width="20%"
    height="60%"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="true"
    [(visible)]="showUsersListPopup"
    (onHidden)="selectedWorkflow = null"
>
    <div *dxTemplate="let data of 'content'">
        <dx-list
            selectionMode="none"
            pageLoadMode="scrollBottom"
            noDataText="No Responsible Users"
            searchExpr="displayName"
            [dataSource]="selectedWorkflow.dashboardResponsibleUsers"
            [searchEnabled]="true"
            [focusStateEnabled]="false"
            [activeStateEnabled]="false"
            [hoverStateEnabled]="false"
        >
            <div *dxTemplate="let user of 'item'" class="responsibleusers-listitem">
                <app-user-bio-link [user]="user" [communityId]="selectedWorkflow.communityId"></app-user-bio-link>
            </div>
        </dx-list>
    </div>
</dx-popup>

<app-workflow-notes-editor
    *ngIf="showWorkFlowNotesPopUp"
    [workflowId]="selectedWorkflow.workflowId"
    [communityId]="selectedWorkflow.communityId"
    [hasNotes]="selectedWorkflow.hasNotes"
    (closeNotesPopUp)="onWorkflowNotesPopClose($event)"
></app-workflow-notes-editor>

<app-workflow-history
    *ngIf="showWorkFlowHistoryPopUp"
    [workflowId]="selectedWorkflow.workflowId"
    [communityId]="selectedWorkflow.communityId"
    (onClose)="onLogClose()"
></app-workflow-history>

<dx-popup
    #workflowPopup
    width="99%"
    height="99%"
    [title]="workflowEditorTitle"
    [showCloseButton]="false"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [(visible)]="showWorkFlowPopUp"
>
    <div *dxTemplate="let data of 'content'" class="workflow-content">
        <app-workflow-editor
            #workflowEditor
            *ngIf="showWorkFlowPopUp"
            [workflowId]="selectedWorkflow.workflowId"
            [communityId]="selectedWorkflow.communityId"
            [status]="selectedWorkflow.status"
            [isPopupMode]="true"
            (closeParentContainer)="onWorkflowClose()"
        ></app-workflow-editor>
    </div>
</dx-popup>

<app-workflow-viewer
    *ngIf="showWorkflowViewer"
    [viewOnly]="true"
    [workflowId]="selectedWorkflow.workflowId"
    [communityId]="selectedWorkflow.communityId"
    (onClose)="onWorkflowViewerClose()"
></app-workflow-viewer>

<app-workflow-community-attribution
    *ngIf="showCommunityAttribution"
    [workflowId]="selectedWorkflow?.workflowId"
    [workflowStatus]="selectedWorkflow?.status"
    (onCommunityAttribution)="onCommunityAttributionSave($event)"
    (onClose)="onCommunityAttributionClose($event)"
></app-workflow-community-attribution>

<cc-message-box #queueMessageBox></cc-message-box>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#queueGrid' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
